var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloorplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13211_25148)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1049 21.9566L21.9566 12.1049C22.0145 12.047 22.0145 11.953 21.9566 11.8951L12.1049 2.04344C12.047 1.98552 11.9531 1.98552 11.8951 2.04344L2.04344 11.8951C1.98552 11.953 1.98552 12.047 2.04344 12.1049L11.8951 21.9566C11.9531 22.0145 12.047 22.0145 12.1049 21.9566ZM23.3708 13.5191C24.2097 12.6801 24.2097 11.3199 23.3708 10.4809L13.5191 0.629225C12.6801 -0.209742 11.3199 -0.209742 10.4809 0.629225L0.629225 10.4809C-0.209742 11.3199 -0.209742 12.6801 0.629225 13.5191L10.4809 23.3708C11.3199 24.2097 12.6801 24.2097 13.5191 23.3708L23.3708 13.5191Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1634 13.9323L17.9323 8.16336C18.0226 8.07314 18.0226 7.92686 17.9323 7.83664L12.1634 2.06767C12.0731 1.97744 11.9269 1.97744 11.8366 2.06767L6.06767 7.83664C5.97744 7.92686 5.97744 8.07314 6.06767 8.16336L11.8366 13.9323C11.9269 14.0226 12.0731 14.0226 12.1634 13.9323ZM19.3465 9.57758C20.2178 8.7063 20.2178 7.2937 19.3465 6.42242L13.5776 0.653454C12.7063 -0.217817 11.2937 -0.217818 10.4224 0.653453L4.65345 6.42242C3.78218 7.29369 3.78218 8.7063 4.65345 9.57757L10.4224 15.3465C11.2937 16.2178 12.7063 16.2178 13.5776 15.3465L19.3465 9.57758Z",
    fill: "#55489E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13211_25148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorplate);
export default __webpack_public_path__ + "static/media/floorplate.447781bf.svg";
export { ForwardRef as ReactComponent };